module.exports = __webpack_public_path__ + "static/img/upload-npwp.50b534b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/upload-npwp.jpg
// module id = 0n1X
// module chunks = 36